<template>
  <v-app
    :class="{ 'primary-background': backgroundPrimary === true }"
  >
    <v-main>
      <v-container
        class="d-flex flex-column main-container"
        style="height: 100%;"
        fluid
      >
        <v-row
          :class="$vuetify.breakpoint.mobile ? 'd-flex justify-end align-end' : 'd-flex justify-center align-center'"
        >
          <v-col
            cols="12"
            sm="8"
            :md="wideLayoutRoutes.includes($route.name) ? '6' : '4'"
            :style="{ padding: $vuetify.breakpoint.mobile ? '0 !important' : '' }"
          >
            <slot />
          </v-col>
        </v-row>
        <v-container
          v-if="!$vuetify.breakpoint.mobile"
          class="footer"
        >
          <v-row
            no-gutters
            class="d-flex justify-start"
          >
            <v-col
              cols="12"
              sm="6"
            >
              <span
                class="font-weight-medium text-white"
              >
                {{ name }}
              </span>
            </v-col>

            <v-col
              cols="12"
              sm="6"
              class="d-flex justify-end"
            >
              <div
                class="font-weight-medium text-white"
              >
                <span>{{ phoneNumber }}</span>
                <span class="footer-separator">|</span>
                <router-link
                  :to="{ name: 'PrivacyPolicy' }"
                  class="footer-link text-white"
                >
                  <span class="footer-link-text">{{ $t('base.privacy_policy') }}</span>
                </router-link>
                <span class="footer-separator">|</span>
                <router-link
                  :to="{ name: 'AccountDeletion' }"
                  class="footer-link text-white"
                >
                  <span class="footer-link-text">{{ $t('base.account_deletion') }}</span>
                </router-link>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters } = createNamespacedHelpers('base/config')
export default {
  name: 'CenteredLayout',

  props: {
    backgroundPrimary: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      wideLayoutRoutes: ['Cookies', 'PrivacyPolicy', 'AccountDeletion']
    }
  },

  computed: {
    ...mapGetters({
      name: 'companyName',
      phoneNumber: 'companyPhoneNumber'
    })
  }
}
</script>

<style lang="scss">
.primary-background {
  background-image: url('@/assets/images/login-background-image.png') !important;
  background-color: #000000 !important;

  background-repeat: no-repeat !important;   // Prevent tiling
  background-size: cover !important;        // Scale image to cover entire container
  background-position: center center !important; // Center image
  width: 100vw;   // Ensure full viewport width
  height: 100vh;  // Ensure full viewport height
}

.footer {
  max-width: 1720px;
  padding: 0 3rem 2rem 3rem;
}

.text-white {
  color: white;
}

.footer-separator {
  margin: 0 0.5rem;
}

.footer-link {
  color: inherit;
  text-decoration: none;
}

.footer-link-text {
  text-decoration: underline;
}
</style>
